import { AppKind, TellentClientConfig } from '@core/tellent-types';

import { setupClient } from './demo-client-setup';
import { TellentClient } from '../app/tellent-client';

export const demoApp = (appKind: AppKind, config: TellentClientConfig) => {
  const client = new TellentClient(config);

  client
    .initWithSelfAuth(appKind)
    .then(data => {
      setupClient(client, data, appKind);
    })
    .catch(err => {
      console.error(err);
    });

  return client;
};
